import React, { useState } from "react";
import logo from "../images/logo.png";

const styles = {
  logo: {
    width: 200
  },
  nav: {
    backgroundColor: "black"
  }
};

let menuList = [
  { id: 1, menuName: "About Us", url: "#about-us" },
  { id: 2, menuName: "Our Team", url: "#our-team" },
  { id: 3, menuName: "Our Events", url: "#events" },
  { id: 4, menuName: "Contact Us", url: "#contact-us" }
];

export default function Navbar() {
  let [navbarState, setNavbarState] = useState(false);
  let [navbarClass, setNavbarClass] = useState("collapse navbar-collapse");
  function toggler() {
    if (navbarState) {
      setNavbarState(false);
      setNavbarClass("collapse navbar-collapse");
    } else {
      setNavbarState(true);
      setNavbarClass("collapse navbar-collapse show text-center");
    }
  }
  return (
    <nav style={styles.nav} className="navbar navbar-expand-sm text-white">
      <img style={styles.logo} src={logo} alt="GS Logo" />
      <button className="navbar-toggler" type="button" onClick={toggler}>
        <span className="text-white">Menu</span>
      </button>
      <div className={navbarClass}>
        <ul className="navbar-nav ml-auto mr-5 ">
          {menuList.map(menu => {
            return (
              <li key={menu.id} className="nav-item p-3">
                <a href={menu.url} className="text-white">
                  {menu.menuName}
                </a>
              </li>
            );
          })}
        </ul>
      </div>
    </nav>
  );
}
